import dayjs from "dayjs";
import { useState } from "react";
import { Button } from "antd";

import "./index.css";
import DateRange from "../DateRange";
import History from "../History";
import Header from "../Header";
import Footer from "../Footer";
import Settings from "../Settings";

function Main() {
  const defaultStartDate = dayjs();
  const defaultNumberOfDays = 7;
  const defaultTitle = "My SCHEDULE";
  const defaultShowWeekdays = false;
  const defaultSlotNames = ["morning", "noon", "evening"];
  const defaultRepeatStep = 1;
  const defaultRepeatUnit = "day";
  const defaultShouldPrintHeader = false;
  const defaultDateFormat = "YYYY-MM-DD";
  const defaultWeekdayFormat = "ddd";

  const [startDate, setStartDate] = useState(
    localStorage.getItem("startDate") ? dayjs(localStorage.getItem("startDate")) : defaultStartDate
  );
  const [numberOfDays, setNumberOfDays] = useState(localStorage.getItem("numberOfDays") || defaultNumberOfDays);
  const [slotNames, setSlotNames] = useState(
    localStorage.getItem("slotNames") ? JSON.parse(localStorage.getItem("slotNames")) : defaultSlotNames
  );
  const [showWeekdays, setShowWeekdays] = useState(
    JSON.parse(localStorage.getItem("showWeekdays")) || defaultShowWeekdays
  );

  const [shouldPrintHeader, setShouldPrintHeader] = useState(
    JSON.parse(localStorage.getItem("shouldPrintHeader") || defaultShouldPrintHeader)
  );
  const [title, setTitle] = useState(localStorage.getItem("title") || defaultTitle);
  const [repeatStep, setRepeatStep] = useState(localStorage.getItem("repeatStep") || defaultRepeatStep);
  const [repeatUnit, setRepeatUnit] = useState(localStorage.getItem("repeatUnit") || defaultRepeatUnit);
  const [dateFormat, setDateFormat] = useState(localStorage.getItem("dateFormat") || defaultDateFormat);
  const [weekdayFormat, setWeekdayFormat] = useState(localStorage.getItem("weekdayFormat") || defaultWeekdayFormat);

  const defaultHistory = {};
  for (let i = 0; i < numberOfDays; i++) {
    defaultHistory[startDate.add(i, "day").format(dateFormat)] = [];
  }
  const [history, setHistory] = useState(
    localStorage.getItem("history") ? JSON.parse(localStorage.getItem("history")) : defaultHistory
  );

  const onDateRangeUpdate = (values) => {
    if (!!!values) return;
    const [from, to] = values;
    const numberOfDays = to.diff(from, "day") + 1;
    setNumberOfDays(numberOfDays); // Include the last day and first day
    setStartDate(from);
    localStorage.setItem("startDate", from.format(dateFormat));
    localStorage.setItem("numberOfDays", numberOfDays);
  };

  const onHistoryUpdate = (day, checkedValues) => {
    const updatedHistory = { ...history };
    updatedHistory[day.format(dateFormat)] = checkedValues;

    localStorage.setItem("history", JSON.stringify(updatedHistory));
    setHistory(updatedHistory);
  };

  const onSetSlotNames = (values) => {
    localStorage.setItem("slotNames", JSON.stringify(values));
    setSlotNames(values);
  };

  const onSetTitle = (title) => {
    localStorage.setItem("title", title);
    setTitle(title);
  };

  const onSetDateFormat = (format) => {
    localStorage.setItem("dateFormat", format);
    setDateFormat(format);
  };

  const onSetWeekdayFormat = (format) => {
    localStorage.setItem("weekdayFormat", format);
    setWeekdayFormat(format);
  };

  const onSetShowWeekdays = (value) => {
    localStorage.setItem("showWeekdays", value);
    setShowWeekdays(value);
  };

  const onSetShouldPrintHeader = (value) => {
    localStorage.setItem("shouldPrintHeader", value);
    setShouldPrintHeader(value);
  };

  const onSetRepeatStep = (value) => {
    localStorage.setItem("repeatStep", value);
    setRepeatStep(value);
  };

  const onSetRepeatUnit = (value) => {
    localStorage.setItem("repeatUnit", value);
    setRepeatUnit(value);
  };

  const onReset = () => {
    setStartDate(defaultStartDate);
    setNumberOfDays(defaultNumberOfDays);
    setSlotNames(defaultSlotNames);
    setHistory(defaultHistory);
    setTitle(defaultTitle);
    setRepeatStep(defaultRepeatStep);
    setRepeatUnit(defaultRepeatUnit);

    localStorage.setItem("startDate", defaultStartDate.format(dateFormat));
    localStorage.setItem("numberOfDays", defaultNumberOfDays);
    localStorage.setItem("history", JSON.stringify(defaultHistory));
    localStorage.setItem("slotNames", JSON.stringify(defaultSlotNames));
    localStorage.setItem("title", defaultTitle);
    localStorage.setItem("showWeekdays", defaultShowWeekdays);
    localStorage.setItem("repeatStep", defaultRepeatStep);
    localStorage.setItem("repeatUnit", defaultRepeatUnit);
  };

  return (
    <>
      <div className="wrapper">
        <Header title={title} shouldPrintHeader={shouldPrintHeader} />
        <div className="Main">
          <DateRange startDate={startDate} numberOfDays={numberOfDays} onSetDateRange={onDateRangeUpdate} />
          <Settings
            slotNames={slotNames}
            onSetSlotNames={onSetSlotNames}
            showWeekdays={showWeekdays}
            onSetShowWeekdays={onSetShowWeekdays}
            dateFormat={dateFormat}
            onSetDateFormat={onSetDateFormat}
            weekdayFormat={weekdayFormat}
            onSetWeekdayFormat={onSetWeekdayFormat}
            title={title}
            onSetTitle={onSetTitle}
            repeatStep={repeatStep}
            onSetRepeatStep={onSetRepeatStep}
            repeatUnit={repeatUnit}
            onSetRepeatUnit={onSetRepeatUnit}
            shouldPrintHeader={shouldPrintHeader}
            onSetShouldPrintHeader={onSetShouldPrintHeader}
          />
          <div className="reset">
            <Button onClick={onReset}>Reset</Button>
          </div>
          <History
            numberOfDays={numberOfDays}
            startFrom={startDate}
            history={history}
            dateFormat={dateFormat}
            slotNames={slotNames}
            onHistoryUpdate={onHistoryUpdate}
            showWeekdays={showWeekdays}
            weekdayFormat={weekdayFormat}
            repeatStep={repeatStep}
            repeatUnit={repeatUnit}
          />
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Main;
